"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaceListSchema = exports.getOrganizationSchema = void 0;
const getOrganizationSchema = (data) => {
    return {
        name: data.nameCompany,
        ...(data.email && { email: data.email }),
        telephone: data.phone,
        address: {
            '@type': 'PostalAddress',
            addressLocality: data.addressLocality,
            streetAddress: data.streetAddress,
            postalCode: data.postalCode,
            addressRegion: data.addressRegion,
            addressCountry: data.addressCountry,
        },
    };
};
exports.getOrganizationSchema = getOrganizationSchema;
const getPlaceListSchema = (data) => {
    return data.map((item) => {
        return {
            '@type': 'Place',
            geo: {
                '@type': 'GeoCoordinates',
                latitude: item.location[0].toString(),
                longitude: item.location[1].toString(),
            },
            address: {
                '@type': 'PostalAddress',
                addressLocality: item.addressLocality,
                addressRegion: item.addressRegion,
                ...(item.postalCode && { postalCode: item.postalCode }),
                streetAddress: item.streetAddress,
                addressCountry: item.addressCountry,
            },
        };
    });
};
exports.getPlaceListSchema = getPlaceListSchema;
